import Center from '@components/common/alignment/Center';
import HorizontalCenter from '@components/common/alignment/HorizontalCenter';
import ContentBox from '@components/common/ContentBox';
import ErrorPage from '@components/common/Error';
import LoadingPage from '@components/common/Loading';
import { GenericAuthContext } from '@src/authContexts';
import { CourseData } from '@data/course/courseData';
import { CourseDataConverter } from '@data/course/CourseDataConverter';
import { truncateText } from '@util/truncateText';
import firebase from 'firebase/app';
import 'firebase/firestore';
import React, { useContext } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { Link } from 'react-router-dom';

const converter = new CourseDataConverter();

const CourseStatusDashboard: React.FC = () => {
  const { user } = useContext(GenericAuthContext);

  const [col, loading, error] = useCollection(
    firebase
      .firestore()
      .collection('classes')
      .where('instructorIds', 'array-contains', user.uid)
      .where('archived', '==', false)
      .orderBy('name', 'desc')
      .withConverter(converter)
  );

  const collection = col as firebase.firestore.QuerySnapshot<CourseData>;

  if (loading) {
    return <LoadingPage></LoadingPage>;
  }

  if (!collection || error) {
    return <ErrorPage></ErrorPage>;
  }

  if (collection.size < 1) {
    return (
      <Center inheritHeight={true}>
        <ContentBox>
          <div className='text-5xl text-coffee font-raleway'>No courses to view.</div>
        </ContentBox>
      </Center>
    );
  }

  return (
    <Center inheritHeight={true}>
      <ContentBox>
        <HorizontalCenter>
          <p className='font-raleway text-deepspace font-bold text-4xl mb-8'>COURSES</p>
        </HorizontalCenter>
        {collection.docs.map((doc, index) => (
          <div key={index} className='mb-4'>
            <Link
              to={`/instructor/courses/${doc.id}`}
              className='text-pewter underline font-raleway text-3xl'
            >
              {truncateText(doc.data().name, 30) || 'Unknown Course'}
            </Link>
          </div>
        ))}
      </ContentBox>
    </Center>
  );
};

export default CourseStatusDashboard;
